import React from 'react';

const CreatetaskIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8067 5.91333V12.1867C13.8067 13.8267 12.4667 15.1667 10.8267 15.1667H5.17336C3.53336 15.1667 2.19336 13.8267 2.19336 12.1867V5.91333C2.19336 4.77333 2.83336 3.78 3.77336 3.28C4.10003 3.10667 4.50669 3.34 4.50669 3.71334C4.50669 4.77334 5.37336 5.64 6.43336 5.64H9.56669C10.6267 5.64 11.4934 4.77334 11.4934 3.71334C11.4934 3.34 11.8934 3.10667 12.2267 3.28C13.1667 3.78 13.8067 4.77333 13.8067 5.91333Z"
      fill="#3F3F46"
    />
    <path
      d="M9.56667 1.83333H6.43334C5.74001 1.83333 5.17334 2.39333 5.17334 3.08666V3.71333C5.17334 4.40666 5.73334 4.96666 6.42667 4.96666H9.56667C10.26 4.96666 10.82 4.40666 10.82 3.71333V3.08666C10.8267 2.39333 10.26 1.83333 9.56667 1.83333Z"
      fill="#3F3F46"
    />
  </svg>
);

export default CreatetaskIcon;
